module.exports = __webpack_public_path__ + "assets/icon-balloon-cross-component.1e04e304.svg";